import { DropdownOption, Option } from 'framework/form';
import { isNestedOption } from 'framework/form/input/dropdownHelper';

export const hasValue = (value: unknown): boolean => {
  if (value === null || value === undefined) {
    return false;
  }

  if (typeof value === 'string') {
    return value.trim().length > 0;
  }

  if (Array.isArray(value)) {
    return value.length > 0;
  }

  if (typeof value === 'number') {
    return !Number.isNaN(value);
  }

  if (typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>).length > 0;
  }

  return true;
};

export const getDropdownValue = (
  multiple: boolean,
  value: unknown,
  options: DropdownOption[],
  getOptionValue?: (option: Option) => string,
) => {
  const flattenedOptions: Option[] = options.flatMap(option => (isNestedOption(option) ? option.options : [option]));
  const resolveOptionValue = (option: Option) => (getOptionValue ? getOptionValue(option) : String(option.value));
  const resolveSelectedValue = (item: unknown) => {
    if (item && typeof item === 'object') {
      const record = item as Record<string, unknown>;
      if ('id' in record) {
        return String(record.id);
      }
      if ('value' in record) {
        if (record.value && typeof record.value === 'object') {
          const valueRecord = record.value as Record<string, unknown>;
          if ('id' in valueRecord) {
            return String(valueRecord.id);
          }
        }
        return String(record.value);
      }
    }
    return String(item);
  };

  if (multiple) {
    const selectedValues = Array.isArray(value) ? value.map((item: unknown) => resolveSelectedValue(item)) : [];

    return flattenedOptions
      .filter(item => !item.disabled && selectedValues.includes(resolveOptionValue(item)))
      .sort((a, b) => selectedValues.indexOf(resolveOptionValue(a)) - selectedValues.indexOf(resolveOptionValue(b)));
  }

  return flattenedOptions.find(item => resolveOptionValue(item) === resolveSelectedValue(value)) || null;
};
